import { Button, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components';
import { Appbar, Menu } from '@galaxy-react/core';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import GlobalMenu from 'src/feature/GlobalMenu';
// import SearchBar from 'src/feature/SearchBar/SearchBar';
import { useLocalStorageState } from 'ahooks';
import Searchbox from 'src/feature/Searchbox';
import AppBarAvatar from './Avatar';
import DownloadPanel from './DownloadPanel';
import Logo from './Logo';

interface IProps {
  title?: string;
  PaperProps?: any;
  possition?: any;
  className?: any;
}

const CustomAppBar: React.FC<React.PropsWithChildren<IProps>> = (props) => {
  const [region, setRegion] = useLocalStorageState('developmentRegion', {
    defaultValue: _APP_LEAP_ENV_,
  });

  const handleRegionChange = (region) => {
    setRegion(region);
    window.location.reload();
  };
  return (
    <Appbar
      menuButton={<GlobalMenu />}
      logo={
        <div style={{ display: 'flex', flex: 'row', alignItems: 'center' }}>
          <RouterLink to="/" style={{ display: 'inline-flex' }}>
            <Logo style={{ cursor: 'pointer' }} />
          </RouterLink>
        </div>
      }
      actions={
        <>
          {process.env.NODE_ENV === 'development' && (
            <Menu positioning={{ autoSize: true }}>
              <MenuTrigger disableButtonEnhancement>
                <Button>Region: {region}</Button>
              </MenuTrigger>

              <MenuPopover>
                <MenuList>
                  <MenuItem onClick={() => handleRegionChange('test.au')}>AU/NZ </MenuItem>
                  <MenuItem onClick={() => handleRegionChange('test.uk')}>UK</MenuItem>
                  <MenuItem onClick={() => handleRegionChange('test.us')}>US</MenuItem>
                  <MenuItem onClick={() => handleRegionChange('test.ca')}>CA</MenuItem>
                </MenuList>
              </MenuPopover>
            </Menu>
          )}
          {/* <Launcher /> */}
          <DownloadPanel key="download" />
          <AppBarAvatar key="avatar" />
        </>
      }
    >
      <Searchbox></Searchbox>
    </Appbar>
  );
};

export default CustomAppBar;
